/**
 * Where the layout worker fetches the curated fonts and hyphenation patterns from (decisions 31, 33; part 12 notes):
 * each file's URL as the build gives it (Vite hashes asset names), looked up by its file name in
 * `packages/layout/fonts/` or `hyphenation/`.
 */

/** File name → URL, from a table of `path → URL` (the path's last segment is the name). Throws for a name given twice. */
export function fileUrls(glob: Readonly<Record<string, string>>): ReadonlyMap<string, string> {
  const urls = new Map<string, string>();
  for (const [path, url] of Object.entries(glob)) {
    const name = path.slice(path.lastIndexOf('/') + 1);
    if (urls.has(name)) throw new Error(`two asset files are named ${name}`);
    urls.set(name, url);
  }
  return urls;
}

/** The URL of the asset named `name`; throws for a name that isn't one, so nothing else is ever fetched. */
export function urlOf(urls: ReadonlyMap<string, string>, name: string): string {
  const url = urls.get(name);
  if (url === undefined) throw new Error(`no asset file is named ${name.slice(0, 64)}`);
  return url;
}
